import React from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';
import useStores from '../hooks/useStores';

const Container = styled.div<{
  gridPosition: number;
}>`
  ${tw`flex items-center gap-4`}
  ${({ gridPosition }) => gridPosition && `-ms-grid-column:  ${gridPosition}`};
  ${({ gridPosition }) => gridPosition && `grid-column:  ${gridPosition}`};
  @media (max-width: 1199px),
    screen and (min-width: 428px) and (max-width: 926px) and (orientation: landscape) {
    display: none;
  }
`;

const TabLabel = styled.h4<{ active: boolean }>`
  ${tw`cursor-pointer font-bold m-0`}
  position: relative;
  font-size: 14px;
  padding-left: 15px;
  padding-right: 15px;

  ${(props) =>
    props.active &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: -23px;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #7687c2;
    }
  `};
`;

type Props = {
  gridPosition: number;
  fullscreen: (() => void) | undefined;
  oneSongWonder: () => void;
};

const PlayerTabs = ({
  gridPosition,
  gridPositionMobile,
  fullscreen,
  oneSongWonder,
}: Props) => {
  const { mediaPlayerStore } = useStores();
  return (
    <Container
      gridPosition={gridPosition}
      gridPositionMobile={gridPositionMobile}
    >
      <TabLabel active={mediaPlayerStore.showSlide} onClick={fullscreen}>
        WORDS ON SCREEN
      </TabLabel>
      <TabLabel active={mediaPlayerStore.showOSW} onClick={oneSongWonder}>
        ONE-SONG WONDER
      </TabLabel>
    </Container>
  );
};

export default PlayerTabs;
